import {Component, OnInit} from '@angular/core';
import {ErrorsStackService} from '@services/errors-stack.service';
import {environment} from '@environments/environment';

@Component({
    selector: 'app-error-page',
    template: `
        <h1>Что-то пошло не так...</h1>

        <p>Во время работы произошла непредвиденная ошибка.</p>

        <div *ngIf="errorInfo">
            <div libDropdown>
                <p>
                    <button type="button" class="link" libDropdownToggle>Информация об ошибке</button>
                </p>
            </div>

            <p *libDropdownContent class="info">
                {{errorInfo}}
            </p>
        </div>

        <br>

        <h2>Почему так вышло?</h2>
        <ul>
            <li>&bull; Вы давно не обновляли страницу и у вас открыта не самая новая версия приложения.</li>
            <li>&bull; Ошибка возникла из-за обработки некорректных данных.</li>
            <li>&bull; Возникла иная исключительная ситуация, которая не возникала на этапе тестирования сервиса перед обновлением.</li>
        </ul>

        <br>

        <h2>Что можно сделать?</h2>

        <g-row align="center">
            <g-col>
                <button class="button-green" (click)="reloadPage()">Обновить страницу</button>
            </g-col>
            <g-col>
                <a [href]="supportUrl" target="_blank" class="button">Написать в поддержку</a>
            </g-col>
        </g-row>
    `
})

export class ErrorPageComponent implements OnInit {

    public errorInfo;
    public supportUrl;

    constructor(
        private errorsStackService: ErrorsStackService,
    ) {
    }

    ngOnInit() {
        this.errorInfo = this.errorsStackService.errors$.getValue();
        this.supportUrl = environment.technicalSupportUrl;
    }

    reloadPage() {
        window.location.assign('/');
    }
}
